<template>
  <div class="filter"
       v-on:click="openFilter"
       v-bind:class="filterClassList"
       ref="filter">
    <div class="filter__button">
      {{ name }}: <span class="filter__selected">{{ selected }}</span>
    </div>
    <ul class="filter__options">
      <VuePerfectScrollbar class="scroll-area" maxScrollbarLength="200">
        <li class="not-selectable">{{ name }} <span v-if="name === 'Income'">(£)</span></li>
        <li v-for="(item, index) in items" v-bind:key="index" v-on:click="selectOption(item)">
          {{ item }}
        </li>
      </VuePerfectScrollbar>
    </ul>
    {{ result }}
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import { mapGetters } from 'vuex'
  import { Bus } from '@/components/Bus'

  export default {
    name: 'TimelineFilter',
    components: {
      VuePerfectScrollbar
    },
    props: {
      name: String,
      items: Array
    },
    data() {
      return {
        isActive: false,
        isSelected: false,
        selected: 'Show All',
        type: this.name.toLowerCase(),
        result: '',
        lastSelected: ''
      }
    },
    computed: {
      ...mapGetters({
        filters: 'getFilters'
      }),
      filterClassList: function () {
        return {
          active: this.isActive,
          selected: this.isSelected
        }
      },
      getFilteredAgeData: function () {
        return this.$store.getters.getFilteredAgeData
      }
    },
    watch: {
      'filters': function () {
        this.checkFilterState()
      }
    },
    methods: {
      checkFilterState: function () {
        this.selected = this.$store.state.filters[this.type]
        this.lastSelected = this.selected
        if (this.selected === 'Show All') {
          this.isSelected = false
        } else {
          this.isSelected = true
        }
      },
      openFilter: function () {
        this.isActive = !this.isActive
      },
      selectOption: function (item) {
        this.applySelected(item)

        this.$store.dispatch('applyFilters').then(() => {
          Bus.$emit('filterChanged')
          this.$root.$router.push({
            query: Object.assign({}, this.$route.query, { [this.type]: this.selected })
          })
          this.lastSelected = this.selected
          Bus.$emit('checkFilterState')
        }).catch(() => {
          // No results available so reset
          this.applySelected(this.lastSelected)
          Bus.$emit('checkFilterState')
        })
      },
      applySelected: function (item) {
        this.isActive = this.isActive
        this.$store.commit('setFilter', {
          [this.type]: item
        })
        this.selected = this.$store.state.filters[this.type]
        this.isSelected = true
      },
      documentClick: function (e) {
        let el = this.$refs.filter
        let target = e.target

        if ((el !== target) && (!el.contains(target))) {
          this.isActive = false
        }
      }
    },
    beforeMount: function (item) {
      this.checkFilterState()
      Bus.$on('checkFilterState', () => {
        this.checkFilterState()
      })
    },
    beforeDestroy: function () {
      this.$store.commit('resetFilters')
    },
    created() {
      document.addEventListener('click', this.documentClick)
    },
    destroyed() {
      document.removeEventListener('click', this.documentClick)
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/core/vars.scss';
  @import '../styles/core/mixins.scss';

  .filter {
    position: relative;
    .scroll-area

  {
    position: relative;

    @include respond-to('medium') {
      max-height: 60vh;
    }
  }

  @include respond-to('medium') {
    flex: 0 0 calc(20% - 20px);
    max-width: calc(20% - 20px);
    width: 100%;
    margin-top: 20px;
    margin: 0 10px;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &__button {
    color: $c-pink;
    font-size: 26px;
    display: block;
    padding-top: 10px;
    border-radius: 0 0 25px 25px;

    @include respond-to('medium') {
      color: $c-white;
      border: 2px solid $c-white;
      border-radius: 50px;
      padding: 15px;
      font-weight: 600;
      transition: all 0.2s ease-in-out;
      font-size: 16px;
    }

    .filter__selected

  {
    font-family: $f-body;
    font-weight: 300;
    display: block;
    width: 100%;
    font-size: 16px;
    padding: 15px 0;
    margin-top: 10px;
    background-color: rgba(0, 0, 0, 0.05);
    text-decoration: none;
    color: $c-blue;
    transition: all 0.2s ease-in-out;

    @include respond-to('medium') {
      margin: 0;
      font-size: 14px;
      display: block;
      width: 100%;
      color: $c-white;
      background-color: transparent;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
      padding: 5px 0;
    }
  }

  &:hover {
    cursor: pointer;
    background-color: $c-white;
    color: $c-pink;
    .filter__selected

  {
    color: $c-pink;
  }

  }
  }

  &.selected {
    .filter__button

  {
    background-color: $c-white;
    color: $c-pink;
  }

  .filter__selected {
    color: $c-pink;
  }

  }

  &__options {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    width: 100%;
    bottom: 0;
    background-color: $c-white;
    overflow: hidden;
    height: 0;

    @include respond-to('medium') {
      border-radius: 30px;
      height: auto;
      box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.4);
    }

    li

  {
    color: $c-blue;
    padding: 8px 14px;
    font-family: $f-body;
    font-size: 14px;
    line-height: 22px;
    &:hover

  {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.05);
  }

  &:first-child {
    font-family: $f-title;
    color: $c-pink;
    text-decoration: underline;
    font-size: 18px;
  }

  }
  }

  &.active {
    .filter__options

  {
    height: auto;
    position: relative;
    opacity: 1;
    pointer-events: auto;

    @include respond-to('medium') {
      position: absolute;
    }
  }

  }

  @include respond-to('medium') {
    // opacity: 0;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/Filter.vue